import { checkOPFSWriteSupport } from "@/utils";

import { type PhotoStorage } from "./PhotoStorage.types";
import { PhotoStorageDb } from "./PhotoStorageDb";
import { PhotoStorageFs } from "./PhotoStorageFs";

const createPhotoStorage = async (): Promise<PhotoStorage> => {
    const supported = await checkOPFSWriteSupport();

    console.log("[PhotoStorage]", supported ? "opfs" : "idb");

    return supported ? new PhotoStorageFs() : new PhotoStorageDb();
};

let _photoStorage: PhotoStorage | null = null;
const _ready = createPhotoStorage().then((s) => {
    _photoStorage = s;
});

export const photoStorage = new Proxy({} as PhotoStorage, {
    get(_target, prop: string) {
        return (...args: unknown[]) =>
            _ready.then(() => {
                if (!(prop in _photoStorage!)) return undefined;

                const method = _photoStorage![prop as keyof PhotoStorage];

                if (typeof method === "function") {
                    return (method as (...args: unknown[]) => unknown).apply(
                        _photoStorage,
                        args,
                    );
                }
                return method;
            });
    },
});
